// Mock data for Apex Quality Consultancy website

export const company = {
  name: "Apex Quality Consultancy",
  legalName: "APEX QUALITY CONSULTANCY PTY LTD",
  shortName: "Apex Quality",
  tagline: "Audit Informed NDIS Compliance Consultancy",
  phone: "0411 897 396",
  phoneRaw: "+61411897396",
  phone2: "0410 918 579",
  phoneRaw2: "+61410918579",
  phonesLine: "0411 897 396 | 0410 918 579",
  email: "info@apexconsult.com.au",
  address: "Melbourne, Victoria",
  serviceArea: "Australia wide remote consultancy support available",
  hours: "Monday to Friday, 9:00am to 5:30pm AEST",
  abn: "24 698 263 231",
  acn: "698 263 231",
  bookingLink: "#",
  logoUrl: "/apex-logo.png?v=3",
  footerTagline:
    "Practical NDIS registration, compliance and audit readiness support informed by senior experienced accredited auditors.",
};

// Hero stats strip (Home page) — premium social proof stat cards
export const trustStats = [
  {
    number: "AU",
    title: "Australia Wide",
    text: "Remote consultancy support in every state and territory.",
  },
  {
    number: "All",
    title: "Modules Supported",
    text: "Verification, Core Certification and every supplementary module.",
  },
  {
    number: "Senior",
    title: "Accredited Auditors",
    text: "Guidance informed by senior experienced accredited auditors.",
  },
];

// Hero trust badges (mini row inside the hero — icon + title + short description)
export const heroTrustBadges = [
  {
    icon: "ShieldCheck",
    title: "Senior Experienced Accredited Auditors",
    text: "Real audit expertise behind our guidance.",
  },
  {
    icon: "Award",
    title: "Audit Informed Guidance",
    text: "Support informed by real audit expectations.",
  },
  {
    icon: "Layers",
    title: "Verification, Core & Supplementary Modules",
    text: "Support across multiple pathways and provider types.",
  },
  {
    icon: "ClipboardCheck",
    title: "Practical Evidence Readiness Support",
    text: "Helping you build the evidence auditors look for.",
  },
];

// Authority section cards (replaces the old Trusted-By providers grid)
export const authorityCards = [
  {
    icon: "ShieldCheck",
    title: "Audit Informed Guidance",
    text: "Practical support informed by real audit expectations and provider implementation requirements.",
  },
  {
    icon: "Target",
    title: "Implementation Focused Support",
    text: "Beyond documentation with practical guidance around compliance systems and evidence readiness.",
  },
  {
    icon: "Layers",
    title: "Verification, Core & Supplementary Modules",
    text: "Support across multiple registration pathways and provider types.",
  },
  {
    icon: "CalendarCheck",
    title: "Ongoing Compliance Guidance",
    text: "Supporting providers beyond registration through audit readiness and continuous improvement.",
  },
];

// "Achieve NDIS Registration" benefits (Home page section)
export const registrationBenefits = [
  {
    title: "Documentation Quality Commitment",
    text: "If a compliance issue arises directly from documents we provided, we fix it at no extra cost.",
  },
  {
    title: "NDIS Compliant Documentation",
    text: "Tailored policies, procedures, forms and registers — ready for verification or certification.",
  },
  {
    title: "Audit Readiness Support",
    text: "Internal audits, mock audit preparation and 1:1 lead auditor guidance before your external audit.",
  },
  {
    title: "Audit Process Support",
    text: "Practical help responding to nonconformities and strengthening evidence between audit cycles.",
  },
];

// Apex 4-step process (Home page)
export const registrationSteps = [
  {
    step: "01",
    icon: "PhoneCall",
    title: "Discovery Call",
    text: "Understanding your registration scope, provider goals and compliance requirements.",
  },
  {
    step: "02",
    icon: "FileSignature",
    title: "Registration Preparation",
    text: "Practical documentation, systems and compliance preparation aligned with NDIS Practice Standards.",
  },
  {
    step: "03",
    icon: "ShieldCheck",
    title: "Audit Readiness Support",
    text: "Guidance informed by real audit expectations, implementation requirements and evidence readiness.",
  },
  {
    step: "04",
    icon: "Users2",
    title: "Ongoing Compliance Guidance",
    text: "Supporting providers beyond registration with practical ongoing compliance support.",
  },
];

// NDIS Business Opportunity stats (industry context section)
export const ndisOpportunity = {
  heading: "The NDIS Opportunity",
  subheading:
    "Become a registered NDIS provider and access one of Australia's fastest-growing care markets.",
  body:
    "The NDIS allocates over $45 billion in funding to more than 640,000 Australians with a disability. Registered providers can earn competitive hourly and daily rates for the supports they deliver, depending on service type and location.",
  stats: [
    { value: "$45B+", label: "Annual NDIS funding" },
    { value: "640K+", label: "Participants supported" },
    { value: "$439/hr", label: "Top hourly support rate" },
    { value: "$5,673/day", label: "Top daily support rate" },
  ],
  reference: "Refer to the NDIS Pricing Arrangements and Price Limits for full details.",
};

// Services — short, scannable copy
export const services = [
  {
    slug: "ndis-registration",
    icon: "FileCheck2",
    title: "NDIS Registration Support",
    short: "End-to-end registration pathway guidance for new providers.",
    description:
      "Registration pathway guidance, registration group selection, application support and preparation for verification or certification audit.",
    bullets: [
      "Registration pathway and scope review",
      "Online application and self-assessment support",
      "NDIS compliant documentation preparation",
      "File setup and evidence guidance",
      "Audit readiness planning",
    ],
  },
  {
    slug: "documentation-compliance-systems",
    icon: "ShieldCheck",
    title: "NDIS Documentation & Compliance Systems",
    short:
      "Practical NDIS compliant documentation, policies, procedures, forms, registers and compliance systems aligned with provider registration scope and audit readiness requirements.",
    description:
      "Practical NDIS compliant documentation, policies, procedures, forms, registers and compliance systems aligned with provider registration scope and audit readiness requirements. We focus on implementation, evidence readiness and the systems that make audit preparation practical and sustainable.",
    bullets: [
      "Tailored policies, procedures, forms and registers",
      "Verification, Core Module and supplementary modules",
      "Implementation systems and evidence frameworks",
      "Worker, participant and governance records",
      "Audit evidence checklists and self-assessment support",
    ],
  },
  {
    slug: "audit-readiness-reviews",
    icon: "ClipboardCheck",
    title: "Audit Readiness Reviews",
    short: "Pre-audit review of documents, files and implementation evidence.",
    description:
      "A practical review before Stage 1, Stage 2, mid-term or renewal audit covering governance, participant records, staff files, training evidence, registers and continuous improvement.",
    bullets: [
      "Policy and procedure review",
      "Participant and staff file review",
      "Register review",
      "Interview preparation",
      "Evidence checklist and gap report",
    ],
  },
  {
    slug: "internal-audit-support",
    icon: "SearchCheck",
    title: "Internal Audit Support",
    short: "Internal audits to strengthen governance and continuous improvement.",
    description:
      "Identify gaps, strengthen governance and maintain continuous improvement systems through structured internal audits.",
    bullets: [
      "Internal audit planning",
      "Evidence sampling",
      "Participant and staff file review",
      "Governance and risk review",
      "Findings, recommendations and tracking",
    ],
  },
  {
    slug: "corrective-action-support",
    icon: "Wrench",
    title: "Corrective Action Support",
    short: "Practical help to respond to nonconformities and audit findings.",
    description:
      "Prepare corrective action plans, update evidence and strengthen systems after audit findings.",
    bullets: [
      "Review of nonconformity reports",
      "Root cause analysis",
      "Corrective action plan drafting",
      "Evidence and document updates",
      "System strengthening to prevent repeat findings",
    ],
  },
  {
    slug: "ongoing-compliance-support",
    icon: "CalendarCheck",
    title: "Ongoing Compliance Support",
    short: "Monthly compliance support for registered providers.",
    description:
      "Policy updates, register review, file checks, internal audit scheduling and compliance coaching to keep providers audit-ready.",
    bullets: [
      "Monthly compliance check-ins",
      "Policy and procedure updates",
      "Register and file reviews",
      "Incident and complaints monitoring",
      "Mid-term and renewal audit preparation",
    ],
  },
];

// PRICING — 3 packages (updated per latest specification)
export const pricingPackages = [
  {
    slug: "diy-compliance-pack",
    number: "01",
    name: "DIY Compliance Pack",
    startingPrice: "From $449 + GST",
    badge: null,
    description:
      "Affordable, structured NDIS compliance documentation for providers who are comfortable customising and managing their own documents.",
    suitableFor:
      "Providers who want an affordable documentation package and are confident managing the registration preparation themselves.",
    icon: "FileText",
    breakdown: [
      { type: "Verification DIY Pack", price: "$449 + GST" },
      { type: "Core Certification DIY Pack", price: "$1,499 + GST" },
      { type: "Supplementary Module DIY Pack", price: "$499 + GST per module" },
    ],
    includes: [
      "Editable Word and Excel documents",
      "Verification, Core or Supplementary Module documentation",
      "Policies, procedures, forms and registers",
      "Guidance notes and examples",
      "Audit preparation checklist",
    ],
    cta: "Get DIY Pack",
    popular: false,
    customQuote: false,
  },
  {
    slug: "premium-registration-audit-preparation",
    number: "02",
    name: "Premium Registration & Audit Preparation",
    startingPrice: "From $1,895 + GST",
    badge: "Most Popular",
    description:
      "Complete compliance support, from customised documentation through to audit preparation.",
    suitableFor:
      "Providers who want their documentation professionally prepared and customised, together with practical support to prepare for their external audit.",
    icon: "Award",
    breakdown: [
      { type: "Verification + Premium Audit Preparation", price: "$1,895 + GST" },
      { type: "Core Certification + Premium Audit Preparation", price: "$3,795 + GST" },
      { type: "Additional Module Audit Preparation", price: "$749 + GST per module" },
    ],
    includes: [
      "Customised documents with your logo and branding",
      "PRODA, myID and RAM guidance",
      "Email and phone support during preparation",
      "NDIS Commission application and self-assessment support",
      "Mock audit preparation",
      "Director and staff audit training",
      "Staff and participant file preparation guidance",
      "Non-conformity closure guidance",
    ],
    cta: "Enquire Now",
    popular: true,
    customQuote: false,
  },
  {
    slug: "customised-stage-2-audit-readiness",
    number: "03",
    name: "Customised Stage 2 Audit Readiness",
    startingPrice: "Customised Package",
    priceSub: "Contact us for a tailored quote",
    badge: "Customised",
    description:
      "Practical Stage 2 audit preparation tailored to your registration scope, participants, workers, applicable modules and current level of readiness.",
    suitableFor:
      "Providers preparing for their Stage 2 certification audit who need practical support with implementation, participant and worker files, records, operational evidence and audit preparation.",
    icon: "Layers",
    breakdown: [],
    includes: [
      "Compliance gap assessment against applicable modules",
      "Participant file readiness and preparation",
      "Worker and HR file readiness and preparation",
      "Governance, registers and operational evidence review",
      "Internal audit, readiness report and action plan",
      "Emergency, disaster and continuity readiness",
      "Director and staff audit training and interview preparation",
      "Email and phone support during the agreed preparation period",
      "Guidance responding to auditor document requests and non-conformities, where required",
    ],
    tailoredPricing:
      "Pricing is tailored based on your registration scope, number of participants and workers, applicable supplementary modules, current compliance systems and level of preparation required.",
    cta: "Request a Custom Quote",
    popular: false,
    customQuote: true,
  },
];

// Helper line shown beneath the pricing cards
export const pricingHelperLine =
  "Supplementary modules can be added to Packages 01 and 02. Multi-module discounts apply to eligible packages. Customised Stage 2 support is quoted separately based on the provider's audit requirements and scope.";

// Unified comparison table — columns are the 3 packages, rows are features
export const featureComparison = {
  headers: [
    "",
    "DIY Compliance Pack",
    "Premium Registration & Audit Preparation",
    "Customised Stage 2 Audit Readiness",
  ],
  subHeaders: ["", "", "Most Popular", "Customised"],
  rows: [
    { label: "Starting price", values: ["$449 + GST", "$1,895 + GST", "Custom Quote"] },
    { label: "Editable Word & Excel documents", values: ["Yes", "Yes", "As required"] },
    {
      label: "Policies, procedures, forms & registers",
      values: ["Yes", "Customised", "Existing systems reviewed as required"],
    },
    { label: "Logo and branding applied", values: ["No", "Yes", "Yes"] },
    { label: "PRODA / myID / RAM guidance", values: ["No", "Yes", "As required"] },
    { label: "Application & self-assessment support", values: ["No", "Yes", "As required"] },
    { label: "Email & phone support", values: ["Limited", "Yes", "Yes"] },
    { label: "Mock audit preparation", values: ["No", "Yes", "Yes"] },
    { label: "Director & staff audit training", values: ["No", "Yes", "Yes"] },
    {
      label: "Staff & participant file preparation",
      values: ["No", "Guidance", "Detailed preparation support"],
    },
    { label: "Participant file readiness review", values: ["No", "Guidance", "Yes"] },
    { label: "Worker & HR file readiness review", values: ["No", "Guidance", "Yes"] },
    { label: "Governance & operational evidence review", values: ["No", "Yes", "Yes"] },
    { label: "Internal audit & readiness report", values: ["No", "No", "Yes"] },
    { label: "Emergency, disaster & continuity readiness", values: ["No", "Yes", "Yes"] },
    { label: "Auditor request / corrective-action guidance", values: ["No", "Yes", "Yes"] },
  ],
};

// "Which package is right for you?" — 3 quick choosers
export const packageChooser = [
  {
    slug: "diy-compliance-pack",
    title: "Choose DIY if…",
    text: "You are comfortable customising and managing your own compliance documentation and want to keep your preparation costs lower.",
    cta: "Get DIY Pack",
  },
  {
    slug: "premium-registration-audit-preparation",
    title: "Choose Premium if…",
    text: "You want professionally customised documentation together with registration guidance, audit training and practical preparation for your external audit.",
    cta: "Enquire Now",
  },
  {
    slug: "customised-stage-2-audit-readiness",
    title: "Choose Stage 2 if…",
    text: "You already have your compliance framework in place and need practical support preparing participant files, worker and HR files, operational records, implementation evidence and your organisation for a Stage 2 certification audit.",
    cta: "Request a Custom Quote",
  },
];

// Multi-module discount table (Pricing page)
export const multiModuleDiscounts = [
  { label: "2 modules", value: "Save $200" },
  { label: "3 modules", value: "Save $300" },
  { label: "4 modules", value: "Save $400" },
  { label: "5 or more modules", value: "Contact us for a tailored quote" },
];

export const multiModuleNote =
  "Multi-module discounts apply to eligible Packages 01 and 02. Customised Stage 2 Audit Readiness packages are quoted separately.";

// Pricing-page FAQs (updated — 8 questions)
export const pricingFaqs = [
  {
    q: "Are external audit fees included?",
    a: "No. Apex consultancy and documentation fees do not include fees charged by an independent Approved Quality Auditor. Providers engage and pay their external auditor separately.",
  },
  {
    q: "What is the Documentation Quality Commitment?",
    a: "If a compliance issue arises directly because of documentation supplied by Apex, we will work with you to correct the relevant documentation issue at no additional cost. This does not guarantee registration or a particular external audit outcome.",
  },
  {
    q: "Can you add my logo and business details?",
    a: "Yes. Customised packages can include your organisation's logo, business information and relevant operational details throughout the documentation.",
  },
  {
    q: "Can you help with PRODA, myID and RAM?",
    a: "Yes. Package 02 includes practical guidance with PRODA, myID, RAM and the NDIS registration application process where applicable.",
  },
  {
    q: "Which package is right for me?",
    a: "The DIY Compliance Pack is designed for providers who are comfortable managing and customising their own documentation. Premium Registration & Audit Preparation is designed for providers who want professionally customised documentation together with practical registration and audit preparation. Customised Stage 2 Audit Readiness is designed for providers who need more detailed preparation of their operational evidence, participant records, worker records and implementation before a Stage 2 certification audit.",
  },
  {
    q: "How is Customised Stage 2 Audit Readiness priced?",
    a: "Stage 2 preparation is individually quoted because the amount of work depends on factors such as your registration scope, applicable modules, number of participants and workers, existing documentation, operational evidence and current level of audit readiness.",
  },
  {
    q: "What can Stage 2 audit preparation include?",
    a: "Depending on your registration scope and current level of readiness, Stage 2 preparation may include participant and worker file reviews, service agreements, support plans, participant risk assessments, progress notes and other service-delivery evidence; worker screening, induction, training and competency records; governance records, risk registers, incident management, complaints and feedback, conflicts of interest and continuous-improvement evidence; emergency, disaster and business continuity arrangements; internal audit and readiness assessments; director and worker audit training and interview preparation; and support responding to relevant auditor document requests and non-conformities. The exact preparation is tailored to the applicable NDIS Practice Standards, registration groups and supplementary modules within your audit scope.",
  },
  {
    q: "Are there NDIS Commission application fees?",
    a: "There is no NDIS Commission application fee for provider registration. External Approved Quality Auditor fees and other third-party costs are separate from Apex consultancy fees.",
  },
];

// Home page FAQs — concise, scannable
export const faqs = [
  {
    q: "Is your support audit informed?",
    a: "Yes. Our support is informed by practical audit experience and the NDIS Practice Standards. We work closely with accredited NDIS auditors where required, while keeping consultancy and external audit work clearly separate.",
  },
  {
    q: "Do you only provide templates?",
    a: "No. We provide tailored documentation, implementation guidance, evidence checklists and audit readiness support.",
  },
  {
    q: "Do you support verification and certification?",
    a: "Yes — verification, Core Module certification and all supplementary modules.",
  },
  {
    q: "Can you help after we receive nonconformities?",
    a: "Yes. We provide corrective action support, evidence review and system improvement assistance.",
  },
  {
    q: "Do you support ongoing compliance?",
    a: "Yes. Monthly compliance support, internal audits, register reviews and file checks are available.",
  },
  {
    q: "Are external audit fees included?",
    a: "No. External Approved Quality Auditor fees are not included in Apex package prices.",
  },
];

export const supportedOrgs = [
  { name: "Good Health Disability Services", initials: "GH" },
  { name: "Axis Care Services Pty Ltd", initials: "AC" },
  { name: "Bloomvale Services Pty Ltd", initials: "BV" },
  { name: "Nexivo Disability Services Pty Ltd", initials: "ND" },
  { name: "Single Stop Care Pty Ltd", initials: "SS" },
  { name: "Aanira Care", initials: "AC" },
  { name: "Simply Care 4U", initials: "SC" },
  { name: "Vitium Care Services", initials: "VC" },
  { name: "Covix Care Services", initials: "CC" },
  { name: "Adapt Ability Care WA", initials: "AA" },
  { name: "Excellent Oz Support", initials: "EO" },
  { name: "Upright Care", initials: "UC" },
  { name: "Support Landmark", initials: "SL" },
];

export const whyUs = [
  {
    icon: "ShieldCheck",
    title: "Audit Informed",
    text: "Practical guidance from people who understand what auditors expect.",
  },
  {
    icon: "FileText",
    title: "NDIS Compliant Documentation",
    text: "Policies, procedures and registers tailored to your provider scope.",
  },
  {
    icon: "Target",
    title: "Implementation Focused",
    text: "We help you put systems into practice, not just paperwork.",
  },
  {
    icon: "BadgeCheck",
    title: "Quality Commitment",
    text: "If our documentation causes a compliance issue, we fix it at no extra cost.",
  },
];

export const process = [
  { step: "01", title: "Discovery Call", text: "Discuss your registration pathway, scope and audit timeline." },
  { step: "02", title: "Scope and Proposal", text: "We recommend the right support package for your needs." },
  { step: "03", title: "Documentation and Implementation", text: "NDIS compliant documentation tailored to your scope." },
  { step: "04", title: "Audit Readiness Review", text: "Documents, registers and files reviewed before audit." },
  { step: "05", title: "Ongoing Support", text: "Internal audits, corrective action and renewal preparation." },
];

export const aboutValues = [
  { title: "Integrity", text: "Honest, compliance focused advice — no guarantees we cannot ethically make.", icon: "ShieldCheck" },
  { title: "Audit Knowledge", text: "Informed by practical audit experience and the NDIS Practice Standards.", icon: "Award" },
  { title: "Tailored Support", text: "Work shaped around your registration groups, modules and service scope.", icon: "HeartHandshake" },
  { title: "Implementation Focus", text: "Practical implementation, not just paperwork.", icon: "Target" },
  { title: "Continuous Improvement", text: "Systems that support compliance long after registration.", icon: "Lightbulb" },
];

export const placeholderArticles = [];

export const images = {
  hero: "https://images.unsplash.com/photo-1723433892471-62f113c8c9a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxkaXNhYmlsaXR5JTIwc3VwcG9ydHxlbnwwfHx8fDE3Nzg5MDI5MTN8MA&ixlib=rb-4.1.0&q=85",
  care: "https://images.unsplash.com/photo-1576560665905-28b4d4ea3380?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxjYXJlJTIwc3VwcG9ydHxlbnwwfHx8fDE3Nzg5MDI5MjB8MA&ixlib=rb-4.1.0&q=85",
  connection: "https://images.unsplash.com/photo-1478476868527-002ae3f3e159?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxjYXJlJTIwc3VwcG9ydHxlbnwwfHx8fDE3Nzg5MDI5MjB8MA&ixlib=rb-4.1.0&q=85",
  consulting: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxoZWFsdGhjYXJlJTIwY29uc3VsdGluZ3xlbnwwfHx8fDE3Nzg5MDI5MTR8MA&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHx0ZWFtJTIwbWVldGluZ3xlbnwwfHx8fDE3Nzg5MDI5MjB8MA&ixlib=rb-4.1.0&q=85",
  office: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBvZmZpY2V8ZW58MHx8fHwxNzc4OTAyOTEzfDA&ixlib=rb-4.1.0&q=85",
};
